/** @format */

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import LabelInput from "../../../shared/components/labelInput";
import AddressLookup from "../../../shared/components/addressLookup";
import Tq2Mapper from "../mappers/tq2Mapper";
import FormNavigationButtons from "../../../shared/components/FormNavigationButtons";
import QuoteStep from "../enums/QuoteStep";
import QuoteFormWrapper from "../../../shared/components/quoteFormWrapper";
import { handleNext } from "../../../shared/utils/navigationUtils";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { HotjarEventNames } from "../../../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../../../shared/utils/trackHotjarEvent";
import FieldStack from "../../../shared/components/FieldStack";
import QuoteStepHeading from "../../../shared/components/QuoteStepHeading";
const Tq2 = () => {
  // Form Setup
  const {
    register,
    formState: { errors, isValid },
    watch,
    control,
    setValue,
    trigger,
    handleSubmit,
  } = useForm({
    defaultValues: Tq2Mapper.get(),
  });

  const STATE = useAppStateStore();

  // State
  const [addressError, setAddressError] = useState("");

  const validatePhoneNumber = (value) => {
    let cleanedValue = value.replace(/\D/g, "");

    if (cleanedValue.startsWith("0") && cleanedValue.length === 11) {
      return true;
    }

    if (!cleanedValue.startsWith("0")) {
      return "Phone number must start with zero.";
    }

    if (cleanedValue.length !== 11) {
      return "Phone number must be 11 digits long.";
    }

    return true;
  };

  // Only enable next if lookUpAddress is not null
  const lookUpAddress = watch("lookUpAddress");
  const isManualAddressOpen =
    STATE.enterAddressDriver ?? STATE.enterAddress ?? false;
  const isAddressSelected =
    lookUpAddress !== null && lookUpAddress !== undefined;
  // Event Handlers

  useEffect(() => {
    TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TQ2_ENTERED);
  }, []);

  const onSubmit = (data) => {
    if (isManualAddressOpen) {
      return;
    }

    if (!isAddressSelected) {
      setAddressError("Please look up and select an address.");
      return;
    }
    if (isValid) {
      TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TQ2_NEXT_CLICKED);
    }
    setAddressError("");
    Tq2Mapper.set(data);
    handleNext(QuoteStep.TQ3);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <QuoteFormWrapper>
          <QuoteStepHeading
            title="Contact Details"
            description="Please provide your contact information."
          />

          <FieldStack className="tw-text-sm">
            <div>
            <AddressLookup
              register={register}
              watch={watch}
              control={control}
              setValue={setValue}
              trigger={trigger}
              errors={errors}
              STATE={STATE}
              scope="driver"
              autoLookup
            />
            {addressError && !isAddressSelected && (
              <span className="tw-mt-[5px] tw-block tw-text-sm tw-text-dis-error">
                {addressError}
              </span>
            )}
            </div>
            <LabelInput
              id="phone"
              label="Contact number"
              type="tel"
              inputMode="numeric"
              placeholder="[Phone from Uber]"
              pattern="[0-9]*"
              maxLength={11}
              register={register("phone", {
                required: "Required",
                validate: validatePhoneNumber,
              })}
              trigger={trigger}
              errors={errors.phone}
              watch={watch("phone")}
            />

            <LabelInput
              id="email"
              label="Email"
              type="email"
              placeholder="[Email from Uber]"
              register={register("email", {
                required: "Required",
                pattern: {
                  value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
                  message: "Invalid email address",
                },
              })}
              errors={errors.email}
              watch={watch("email")}
              trigger={trigger}
            />
          </FieldStack>
        </QuoteFormWrapper>
        <FormNavigationButtons
          prevStep={QuoteStep.TQ1}
          isValid={isValid && isAddressSelected && !isManualAddressOpen}
        />
      </form>
    </>
  );
};

export default Tq2;
